import React, { useState } from 'react';
import AdminContext from './AdminContext';

export const AdminProvider = (props) => {

    const [selectedTenant, setSelectedTenantState] = useState(null);
    const [selectedCenter, setSelectedCenter] = useState(null);

    const setSelectedTenant = (tenant) => {
        setSelectedTenantState(tenant);
        setSelectedCenter(null); // nuevo tenant -> se limpia el centro elegido
    };

    return (
        <AdminContext.Provider
            value={{
                selectedTenant,
                setSelectedTenant,
                selectedCenter,
                setSelectedCenter
            }}
        >
            {props.children}
        </AdminContext.Provider>
    );
}